import { ShopId } from 'constants/shop';

/** Base path config for magazine  */
export const pathConfig: {
  [key in ShopId]?: string;
} & {
  'no-config': 'no-config';
} = {
  [ShopId.DE]: 'magazin',
  [ShopId.CH]: 'magazin',
  'no-config': 'no-config',
};

/** Returns the base path for magazine  */
export const getMagazineBathPath = (shopId: ShopId): string => {
  return pathConfig[shopId] ?? pathConfig['no-config'];
};
